import { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';

/**
 * Fires a callback when the returned container comes into view
 * @param {function} callback
 */
export function useViewedEffect(callback) {
    const hasCalledRef = useRef(false);
    const [ref, inView] = useInView({
        threshold: 0.5,
        triggerOnce: true,
    });

    useEffect(() => {
        if (!hasCalledRef.current && inView) {
            hasCalledRef.current = true;
            callback();
        }
    }, [callback, inView]);

    return ref;
}
